export type Theme = 'hell' | 'dunkel';

export function storedTheme(): Theme {
  try {
    return localStorage.getItem('machs.theme') === 'dunkel' ? 'dunkel' : 'hell';
  } catch {
    return 'hell';
  }
}

export function applyTheme(t: Theme) {
  document.documentElement.dataset.theme = t === 'dunkel' ? 'dark' : 'light';
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', t === 'dunkel' ? '#070A12' : '#F3F5FB');
  try {
    localStorage.setItem('machs.theme', t);
  } catch {
    // ohne Speicher gilt die Wahl nur für diese Sitzung
  }
}
